import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import { toCapitalize } from 'yoda-site-components/lib/helpers/Utils/utils';
import { PICKUP_PERSON } from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

function PickupPersonInfo({ pickupPersonInfo }) {
    if (isEmpty(pickupPersonInfo)) {
        return null;
    }
    return (
        <div data-automation-id="at-pickup-person-wrapper">
            <div
                className={dt(['font-open-sans-semibold', 'text-medium', 'text-black'])}
                data-automation-id="at-pickup-person-title"
            >
                {PICKUP_PERSON}
            </div>
            <div className={dt(['text-small', 'text-black'])}>
                <div data-automation-id="at-pickup-person-name" data-qm-block="true" data-tlprivate>
                    {`${toCapitalize(pickupPersonInfo.firstName)} ` +
                        `${toCapitalize(pickupPersonInfo.lastName)}`}
                </div>
                <div
                    style={{ wordBreak: 'break-word' }}
                    className={dt(['!no-underline'])}
                    data-automation-id="at-pickup-person-email"
                    data-qm-block="true"
                >
                    {pickupPersonInfo.email}
                </div>
                <div
                    is
                    x-ms-format-detection="none"
                    className={dt(['!no-underline', 'pt-0'])}
                    data-automation-id="at-pickup-person-phone"
                    data-qm-block="true"
                    data-tlprivate
                >
                    {Formatter.format(pickupPersonInfo.phone, Formatter.TYPE.PHONE)}
                </div>
            </div>
        </div>
    );
}

PickupPersonInfo.propTypes = {
    pickupPersonInfo: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default PickupPersonInfo;
